import React from "react";
const BulkJobNotificationLoader = () => {
  return (
    Array.from({ length: 5 }, (_, i) => (
      <div className="bulkJobItem" key={`skeleton-${i}`}>
        <span className="bjnSkeletonIcon linear-background" />
        <div className="bjnSkeletonContent">
          <span className="bjnSkeletonTitle linear-background" />
          <span className="bjnSkeletonMeta linear-background" />
          <span className="bjnSkeletonBar linear-background" />
        </div>
      </div>
    ))
  )
}
export default BulkJobNotificationLoader;
